import { Avatar, Box, Stack, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ClickableInputBox } from "./CreateContentCommunity.styles";
import { CreateContentCommunityProps } from "./CreateContentCommunity.types";
import { CreateContentModal } from "../../components";
import { POST_TYPE } from "../../consts";
import { useGetProfileImageQuery } from "../../queries";
import { useAuthStore } from "../../stores";
import { stringAvatar } from "../../utils/community";

export function CreateContentCommunity({
  selectedFilter,
  selectedTopic
}: CreateContentCommunityProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleClickOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };
  // get profile img
  const { data: profileImage  } = useGetProfileImageQuery({});
  const anchorEl = document.body;
  const userData = useAuthStore(state => state.userData);




  return (
    <Box>
      <Box
        sx={ {
          width:"100% !important",
          maxWidth:"100%",
          padding: "1rem"
        } }
      >

        <Stack
          direction={ "row" }
          alignItems={ "center" }
          width="100%"
          gap={ isMobile ? "8px" : "16px" }
          onKeyDown={ (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              handleClickOpen();
            }
          } }
        >
          <Avatar
            alt={ `${userData?.name} ${userData?.surname} ` }
            { ...stringAvatar(`${userData?.name} ${userData?.surname} `) }
            sx={ { color: theme.customColors.headerIcon } }
            src={ profileImage }
          />
          <ClickableInputBox
            onClick={ () => handleClickOpen() }
            aria-label={ t("add_new_post") }
          >
            <Typography
              sx={ { 
                color: theme.customColors.textInput, 
                ontSize: "1rem",
                letterSpacing: "0.0313rem"
              } }
            >
              { t("add_new_post") }
            </Typography>
          </ClickableInputBox>
        </Stack>
      </Box>

      {
        isOpen ? (
          <CreateContentModal
            selectedFilter={ selectedFilter }
            selectedTopic={ selectedTopic }
            anchorEl={ anchorEl }
            anchorOrigin={ {
              horizontal: "center",
              vertical: "center"
            } }
            transformOrigin={ {
              horizontal: "center",
              vertical: "top"
            } }
            closeDrawer={ handleClose }
            onClose={  handleClose }
            open={ isOpen }
            postType={ POST_TYPE.FREE }

          />
        ) : null
      }
    </Box>
  );

}
